export enum ENUM_GENDER {
  MALE = 'Male',
  FEMALE = 'Female',
  UNSPECIFIED = 'Unspecified'
}

export type UserType = {
  id: string;
  active: boolean;
  created_at: string;
  email: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  role: string;
  logistics_company_id?: string | null;
  online: boolean;
  profile_image?: string | null;
  bani_account_number?: string | null;
  bani_account_number_providus: string | null;
  free_deliveries: number | string;
  username: string;
  email_confirmed: boolean;
  other_name: null;
  user_gender: ENUM_GENDER;
  dob: string;
  balance: string;
  lat: string | null;
  lng: string | null;
  updated_at: string;
  owe: string;
  year: boolean;
  bani_customer_ref: string | null;
  bani_account_name: string | null;
  cokitchen_id: string;
  cokitchen_staff_number: null;
  cokitchen_polygon_ids?: string[];
  rider_blacklist: boolean;
  rider_average_delivery_time: null;
  thepeer_reference: string | null;
  bani_account_number_gt: string | null;
  bani_account_number_fcmb: string | null;
  bani_account_number_heritage: string | null;
  bani_account_number_stanbic: string | null;
  bani_account_number_9ps: string | null;
  is_deleted: boolean;
  is_in_bin: boolean;
  total_number_of_orders: string;
  basket_abandonment_rate: string;
  is_blacklisted?: boolean;
  brand_ids: string[];
};
